import { render, staticRenderFns } from "./consultaRpv.vue?vue&type=template&id=48433300&"
import script from "./consultaRpv.vue?vue&type=script&lang=js&"
export * from "./consultaRpv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports